/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SportEnum {
    SOCCER = 'SOCCER',
    HOCKEY = 'HOCKEY',
    VOLLEYBALL = 'VOLLEYBALL',
}
